import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'
import { GroupeDialogComponent } from './dialog/groupe-dialog.component'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'


import { StateService } from '../../../../services/state.service'
import { DialogService } from '../../../../services/dialog-service.service'
import { AppService } from '../../../../services/app.service'
 
import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'groupe'

@Component({
  selector: 'atyl-groupe',
  templateUrl: './groupe.component.html',
  styleUrls: ['./groupe.component.scss']
})
@Stringable({
  path: 'views/partials/content/general/groupe',
  key: KEY,
})
export class GroupeComponent implements OnInit {

  @Input() loading:BehaviorSubject<any>=new BehaviorSubject<any>(null);
  
  @StringableValues(KEY) strings: any
  
  @Input() dossier: any;
  @Input() perso: boolean=true;
  @Input() instruction: any;
  
  activeButton:boolean=false;

  forms:any[]=[];
  
  groupes:any[]=[];
  nodeCount:number=0;

  id:any;
  
  associateButton:boolean=true;

  refreshUser: any=null;
  refreshDossier: any=null;

  user:any;
  
  @Input() types: any[]=[];
  
 
  
  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private changeDetectorRef: ChangeDetectorRef,
     private tiersService: AppService
  ) { }

  ngOnInit() {
	this.refreshUser=this.stateService.user.subscribe((user) => {
		 		console.log("user dossier user",user);
		 		if (user) {
		                this.user = user
		                console.log("user dossier",this.user)
						this.loadGroupe();
		            }
		})
		
	 this.refreshDossier=this.loading.subscribe((dossier)=>{
			  if (dossier) {
				  console.log("personne dossier change ",dossier);
				this.dossier=dossier;
				this.loadGroupe();
				}
		 });
	 
		 
		 
	 	
     
    
  }
  
  ngOnDestroy() {
	  	if (this.refreshDossier)
	  		this.refreshDossier.unsubscribe();
	  	if (this.refreshUser)
	  		this.refreshUser.unsubscribe();
    
  }
  
   loadGroupe() {
	   console.log("GroupeComponent load ",this.dossier,this.user);	
	   
	   let _opts:any={
		   
	   }
	  this.groupes=[];
	   
	   
	   
	   if (this.user!=undefined) {
			this.id=this.user.id;
	   }
	   if (this.dossier!=undefined 
		&& this.dossier!=undefined 
		 && this.dossier.ID!=undefined ) {
	   		this.id=this.dossier.ID;
	   }
	      
	    
	   this.tiersService.getGroupe(this.id,_opts).subscribe(
		   (res: JSONRpcResponse) => {
				console.log("GroupeComponent loaded",res);
				if (res.result 
					&& res.result!=undefined
				) {
					this.groupes=res.result;
					this.nodeCount=this.groupes.length;
					this.detectChanges();
				}
					
			}
	   );
	   	
   }
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
   	groupe(event:any) {
		
		let _opts:any={
			id: this.id,
			dossier: this.dossier,
            user: this.user,
			groupes:this.groupes,
			types:this.types,
			personnel: this.perso,
		   }
		console.log("GroupeDialogComponent",_opts);
	    const dialogRef = this.dialogService.open(GroupeDialogComponent, {
            data: _opts,
            draggable: false,
            resizable: false,
         /*   height: (this.perso) ? '50vh': "25vh",*/
			width: "25vw",
        })
        
         dialogRef.afterClosed().subscribe(result => {
            this.loadGroupe();
        });
	   
    }
   
  

}
